function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlashcardBig = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 50,
  height: 50
}, props), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    stroke: "#3a434a",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  },
  d: "M8.15 4.388c-2.081.535-3.688 1.167-5.766 2.271a1.388 1.388 0 0 0-.698 1.533c.814 3.595 1.656 5.9 3.367 9.166.288.551.908.847 1.517.717 3.016-.642 4.893-1.375 7.766-2.987a.274.274 0 0 0 .133-.3",
  transform: "scale(2.5)"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    stroke: "#3a434a",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  },
  d: "M8.477 3.056c.134-.612.66-1.06 1.285-1.09 2.791-.135 4.696.05 7.416.657.624.141 1.07.69 1.086 1.327.097 3.686-.119 6.108-.856 9.678a1.39 1.39 0 0 1-1.283 1.11c-2.798.151-4.71-.02-7.44-.661a1.39 1.39 0 0 1-1.07-1.296c-.154-3.683.066-6.126.862-9.725Zm0 0",
  transform: "scale(2.5)"
}));
export default SvgFlashcardBig;